import React, { Suspense, useEffect } from 'react';
import { Switch, withRouter } from 'react-router-dom';
import { checkAutoLogin } from './services/AuthService';
import { useAuthStore } from './store/authStore';
import { Layout } from './layouts/Layout';
import { authOnlyRoutes, protectedRoutes, publicRoutes } from './routes';
import { PublicRoute, ProtectedRoute, PublicPageRoute } from './components/RouteGuards';
import { AppLockScreen } from './components/AppLockScreen';
import { LanguageProvider } from './i18n/LanguageContext';
import './css/plugins.css';
import './css/style.css';
import './css/templete.css';
import './css/skin/skin-1.css';
import './plugins/slick/slick.min.css';
import './plugins/slick/slick-theme.min.css';

function App(props) {
    useEffect(() => {
        checkAutoLogin(useAuthStore.getState, props.history);
    }, [props.history]);

    const preloader = (
        <div id="preloader">
            <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
            </div>
        </div>
    );

    return (
        <LanguageProvider>
        {/* <AppLockScreen> */}
            <Suspense fallback={preloader}>
                <Switch>
                    {/* 
                        AUTH-ONLY ROUTES (Sin Layout)
                        - Solo accesibles cuando NO estás autenticado
                        - Redirigen a /home si ya estás autenticado
                        - NO tienen Header/Footer
                    */}
                    {authOnlyRoutes.map((route, index) => (
                        <PublicRoute
                            key={route.path || index}
                            path={route.path}
                            exact={route.exact !== undefined ? route.exact : false}
                            component={route.component}
                        />
                    ))}

                    {/*
                        TODAS LAS DEMÁS RUTAS (Con Layout)
                        - Envueltas en Layout para tener Header/Footer
                        - Incluye rutas protegidas y públicas
                    */}
                    <Layout>
                        <Switch>
                            {/* 
                                PROTECTED ROUTES
                                - Solo accesibles cuando estás autenticado
                                - Redirigen a /login si NO estás autenticado
                                - Si requiresApproval=true y es empresa PENDIENTE, redirige a /company-profile
                            */}
                            {protectedRoutes.map((route, index) => (
                                <ProtectedRoute
                                    key={route.path || index}
                                    path={route.path}
                                    exact={route.exact !== undefined ? route.exact : false}
                                    component={route.component}
                                    requiresApproval={route.requiresApproval}
                                />
                            ))}

                            {/* 
                                PUBLIC ROUTES
                                - Accesibles para todos (autenticado o no)
                            */}
                            {publicRoutes.map((route, index) => (
                                <PublicPageRoute
                                    key={route.path || index}
                                    path={route.path}
                                    exact={route.exact !== undefined ? route.exact : false}
                                    component={route.component}
                                />
                            ))}
                        </Switch>
                    </Layout>
                </Switch>
            </Suspense>
        {/* </AppLockScreen> */}
        </LanguageProvider>
    );
}

export default withRouter(App);
